import React from 'react';
import { ButtonGrid, Container, LaundryButton } from './StartLaundryMachineStyles';
import { activateLaundryMachine } from '../../services/laundryService';
import Input from '../../components/Input';
import { Colors } from '../../constants/Colors';

const StartLaundryMachine: React.FC = () => {
  const [pulseDuration, setPulseDuration] = React.useState<string>('150');
  const [pulseInterval, setPulseInterval] = React.useState<string>('100');

  const handleLaundryClick = async (type: string, deviceId: string, pulse: number) => {

    try {
      const payload = {
        deviceId: deviceId,
        type: type,
        pulse: pulse,
        pulseDuration: Number(pulseDuration),
        pulseInterval: Number(pulseInterval),
      };

      activateLaundryMachine(payload);

    } catch (error) {
      console.error(`Erro ao enviar comando`, error);
    }
  };

  return (
    <Container>
      <div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <Input
            label='Duração dos pulsos (ms)'
            type='number'
            value={pulseDuration}
            onChange={(e) => setPulseDuration(e.target.value)}
          ></Input>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', marginBottom: '20px' }}>
          <Input
            label='Intervalo entre os pulsos (ms)'
            type='number'
            value={pulseInterval}
            onChange={(e) => setPulseInterval(e.target.value)}
            style={{ borderColor: Colors.secondary[40], backgroundColor: Colors.secondary[20] }}
          ></Input>
        </div>
        <ButtonGrid>
          <LaundryButton onClick={() => handleLaundryClick('L', 'z7laundry1', 2)}>Lavar 12kg (z7laundry1)</LaundryButton>
          <LaundryButton onClick={() => handleLaundryClick('L', 'z7laundry2', 2)}>Lavar 12kg (z7laundry2)</LaundryButton>
          <LaundryButton onClick={() => handleLaundryClick('L', 'z7laundry3', 1)}>Lavar 14kg (z7laundry3)</LaundryButton>
          <LaundryButton onClick={() => handleLaundryClick('S', 'z7laundry1', 2)}>Secar 12kg (z7laundry1)</LaundryButton>
          <LaundryButton onClick={() => handleLaundryClick('S', 'z7laundry2', 2)}>Secar 12kg (z7laundry2)</LaundryButton>
          <LaundryButton onClick={() => handleLaundryClick('S', 'z7laundry3', 1)}>Secar 14kg (z7laundry3)</LaundryButton>
        </ButtonGrid>
      </div>
    </Container>
  );
};

export default StartLaundryMachine;
